<template>
  <div class="banner">
    <div class="banner-body">
      <icon v-if="icon" class="banner-icon" color="inherit" :name="icon" />
      <div>
        <div v-if="title" class="title">{{ title }}</div>
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    icon: {
      type: String,
      required: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  border: none;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
  font-size: 0.8rem;

  & > .banner-body {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    & > .banner-icon {
      margin-right: 10px;
    }

    & .title {
      font-weight: bold;
    }
  }
}
</style>
